import { Switch } from "@mui/material";
import React from 'react';


export default function SwitchConfig({ children, ...props }) {
    return (
        <Switch color="colorSwitch" {...props}>
        </Switch>
    )
}